module.exports = __webpack_public_path__ + "img/payment-standard.81aa57bc.png";